import React, { Fragment } from "react" ;

const ScrollRails = (props ) =>
{
    return (
        <Fragment>
            <div className="ps__rail-x" style={{left: '0px', bottom: '0px'}}>
                <div className="ps__thumb-x" tabIndex="0" style={{left: '0px', width: '0px'}}/>
            </div>
            <div className="ps__rail-y" style={{top: '0px', right: '0px'}}>
                <div className="ps__thumb-y" tabIndex="0" style={{top: '0px', height: '0px'}}/>
            </div>
        </Fragment>
    )
}

export default ScrollRails ;
